import { render, staticRenderFns } from "./DisplayOffers.vue?vue&type=template&id=15bac8cc&scoped=true&"
import script from "./DisplayOffers.vue?vue&type=script&lang=js&"
export * from "./DisplayOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bac8cc",
  null
  
)

export default component.exports